<template>
    <div class="margin-header">
        <TopBar :title="$vuetify.lang.t('$vuetify.PunchLogSecurity.pageName')" />
        <div class="box-round display-height">
            <div class="box-content px-0">
                <div class="px-7 d-flex pr-8">
                    <div class="flex-auto mr-2">
                        <v-text-field
                            v-model="textSearch"
                            class="custom-input-search search"
                            hide-details="auto"
                            outlined
                            :placeholder="$vuetify.lang.t('$vuetify.PunchLogSecurity.search.placeholder')"
                            @input="inputSearch()"
                        ></v-text-field>
                    </div>
                </div>
                <div class="d-flex flex-nowrap text-sm custom-margin mt-5 line-liff-detail">
                    <v-col cols="6" class="px-0 py-0  text-left pl-7 text-base-grey2">
                        {{textDate}}
                    </v-col>
                </div>
                <div class="mt-5 d-flex flex-nowrap header-item line-liff-detail">
                    <v-col cols="10" class="px-0 py-2 pl-7">
                        {{$vuetify.lang.t('$vuetify.PunchLogSecurity.header.full')}}
                    </v-col>
                    <v-col cols="2" class="px-0 py-2"></v-col>
                </div>
                <div class="line-liff-detail-table">
                  <div class="d-flex flex-nowrap list-item"
                   v-for="(v,i) of list"
                   @click="clickGotoDetail(v.id, v.name)"
                    :key="i">
                      <v-col cols="10" class="px-0 py-2 font-weight-bold pl-7 text-truncate">
                          {{v.name}}
                      </v-col>
                      <v-col cols="2" class="px-0 py-2 text-center">
                        <v-icon>mdi mdi-chevron-right</v-icon>
                      </v-col>
                  </div>
                </div>
            </div>
            <div class="box-footer">
                <div class="bottom-paging">
                    <v-pagination
                      v-model="page"
                      class="my-0 text-sm"
                      :length="numPages"
                      @input="search()"
                    ></v-pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'

import TopBar from '@/components/Liff/Components/header/TopBar.vue'
export default {
    name: 'PunchLogSecurity',
    components: {
        TopBar
    },
    data: function () {
        return {
            lineUserId: null,
            lineLiffId: process.env.VUE_APP_LINE_LIFF_PUNCH_LOG_SECURITY,
            delayTimer: null,
            textSearch: null,
            date: null,
            page: 1,
            totalShow: 20,
            numPages: 1,
            list: []
        }
    },
    computed: {
        textDate: function () {
            const lang = localStorage.getItem('lang')
            const date = this.$dateUtil.formatDate(this.date)
            const [d, m, y] = date.split('/')
            const months = this.$dateUtil.months(lang)
            return `${d} ${months[parseInt(m) - 1]} ${y}`
        }
    },
    created: function () {
        this.date = moment().format('YYYY-MM-DD')
    },
    mounted: function () {
        this.initialData()
    },
    methods: {
        initialData: async function () {
            try {
                const lineUserId = await this.$liffUtil.getLineIdForLiff(this.lineLiffId)
                this.lineUserId = lineUserId
                await this.search()
            } catch {
                // do something with error
            }
        },
        inputSearch: async function () {
            clearTimeout(this.delayTimer)
            this.delayTimer = setTimeout(this.search, 500)
        },
        search: async function () {
            this.$store.dispatch('setLoading', true)
            try {
                const params = {
                    lineId: this.lineUserId,
                    search: this.textSearch,
                    date: this.date,
                    page: this.page
                }
                const res = await this.axios.post('punchlogs/line/security', params)
                if (res && res.data && res.data.status === 'ok') {
                    this.list = res.data.data
                    this.numPages = res.data.numPages
                }
            } catch {
                // do something with error
            }
            this.$store.dispatch('setLoading', false)
        },
        clickGotoDetail: function (id, shortName) {
            this.$router.push('/liff/punch-log/security/' + id + '?shortName=' + shortName)
        }
    }
}
</script>

<style lang="scss" scoped>
    @import '@/styles/color.scss';
    .flex-auto {
        flex: 1;
    }
    .header-item {
        color: $base-grey2;
        background: #d9e4ed;
        font-size: 14px;
    }
    .list-item {
        color: $base-grey3;
        &:not(:last-child){
            border-bottom: 1px solid #e0e0e0;
        }
    }
    ::v-deep .v-pagination__item{
            font-family: LexendDeca;
            font-size:12px;
        }
</style>
